import { createContext, useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";

const AuthContext = createContext(undefined);

const AuthProvider = ({ children }) => {
  // Read user from cookies (if any)
  const [user, setUser] = useState(() => {
    const savedUser = Cookies.get('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  // Set user in cookies whenever it changes
  useEffect(() => {
    if (user) {
      Cookies.set('user', JSON.stringify(user), { expires: 7 }); // cookie expires in 7 days
    } else {
      Cookies.remove('user');
    }
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
